import type { Flow } from "@flow";
import AccordionOverview from "../../components/AccordionOverview/AccordionOverview";
import type { CommonData } from "../../types/common";
import { ProcessWrapper } from "../overview/styles";
import { externalDataSources } from "./sources";

// The tab receives the flat @flow `Flow`; its `data` carries the common-process shape.
const toCommonData = (flow: Flow): CommonData | undefined =>
  flow?.data as unknown as CommonData | undefined;

// The external data sources that have something to show for this case.
const getAvailableSources = (flow: Flow) => {
  const data = toCommonData(flow);
  return externalDataSources.filter((source) => source.isAvailable(data));
};

// Whether the tab should be shown at all (any source has data).
export const hasExternalData = (flow: Flow): boolean =>
  getAvailableSources(flow).length > 0;

export const ExternalDataTab = ({ flow }: { flow: Flow }) => {
  const data = toCommonData(flow);
  const availableSources = getAvailableSources(flow);

  return (
    <ProcessWrapper>
      {availableSources.map(({ id, title, startsExpanded, Component }) => (
        <AccordionOverview
          key={id}
          title={title}
          startsExpanded={startsExpanded ?? false}
        >
          <Component flow={flow} data={data} />
        </AccordionOverview>
      ))}
    </ProcessWrapper>
  );
};
